import { FieldChange } from "./useChangesTracker";

export function getFieldChanges(
  original: any,
  current: any,
  prefix: string = ""
): FieldChange[] {
  const changes: FieldChange[] = [];

  // Handle null/undefined cases
  if (original === current) return changes;
  if (original == null || current == null) {
    if (original !== current) {
      changes.push({
        field: prefix || "root",
        oldValue: original,
        newValue: current,
      });
    }
    return changes;
  }

  // Handle arrays
  if (Array.isArray(original) && Array.isArray(current)) {
    if (JSON.stringify(original) !== JSON.stringify(current)) {
      changes.push({
        field: prefix,
        oldValue: original,
        newValue: current,
      });
    }
    return changes;
  }

  // Handle objects
  if (typeof original === "object" && typeof current === "object") {
    const allKeys = new Set([
      ...Object.keys(original),
      ...Object.keys(current),
    ]);

    allKeys.forEach((key) => {
      const fieldPath = prefix ? `${prefix}.${key}` : key;
      const origValue = original[key];
      const currValue = current[key];

      // Skip if values are identical
      if (origValue === currValue) return;

      // If both are objects/arrays, recurse
      if (
        typeof origValue === "object" &&
        origValue !== null &&
        typeof currValue === "object" &&
        currValue !== null
      ) {
        const nestedChanges = getFieldChanges(origValue, currValue, fieldPath);
        changes.push(...nestedChanges);
      } else if (origValue !== currValue) {
        // Primitive value changed
        changes.push({
          field: fieldPath,
          oldValue: origValue,
          newValue: currValue,
        });
      }
    });

    return changes;
  }

  // Primitive values
  if (original !== current) {
    changes.push({
      field: prefix || "value",
      oldValue: original,
      newValue: current,
    });
  }

  return changes;
}

export function formatFieldValue(value: any): string {
  if (value == null) return "vazio";
  if (Array.isArray(value)) return `[${value.length} item(s)]`;
  if (typeof value === "object") return JSON.stringify(value);
  if (typeof value === "string") return `"${value}"`;
  return String(value);
}
